var _g, _g2, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Untitled design (13) 1",
    clipPath: "url(#clip0_5267_39051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5267_39051",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 0,
    width: 27,
    height: 42
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "d01b9fb59d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.417 0.791016H46.667V41.6251H20.417V0.791016Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5267_39051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.542 0.791016C26.3058 0.791016 20.417 6.6798 20.417 13.916C20.417 20.5632 31.0716 38.8448 32.2849 40.907C32.5474 41.3502 33.0228 41.6243 33.542 41.6243C34.0611 41.6243 34.5366 41.3502 34.799 40.907C36.0153 38.8448 46.667 20.5632 46.667 13.916C46.667 6.6798 40.7782 0.791016 33.542 0.791016ZM33.542 18.291C31.1299 18.291 29.167 16.3282 29.167 13.916C29.167 11.5041 31.1299 9.54101 33.542 9.54101C35.9541 9.54101 37.917 11.5041 37.917 13.916C37.917 16.3282 35.9541 18.291 33.542 18.291Z",
    fill: "url(#paint0_linear_5267_39051)"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M69.4403 21.5171C69.0845 21.24 68.6208 21.1381 68.189 21.2518L46.667 26.633V70.4706L68.895 64.9143C69.5454 64.751 70.0003 64.1705 70.0003 63.4996V22.6663C70.0003 22.2172 69.7932 21.7943 69.4403 21.5171Z",
    fill: "url(#paint1_linear_5267_39051)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.4167 21.5664L1.05881 27.0963C0.431613 27.2771 0 27.8488 0 28.4992V69.3325C0 69.7905 0.215902 70.2221 0.580485 70.4963C0.837023 70.6889 1.14616 70.7909 1.45833 70.7909C1.59258 70.7909 1.72664 70.7734 1.85786 70.7354L20.4167 65.433V21.5664Z",
    fill: "url(#paint2_linear_5267_39051)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M37.3097 42.3857C36.525 43.7157 35.0813 44.5412 33.5413 44.5412C32.0014 44.5412 30.5546 43.7157 29.773 42.3857C28.0988 39.545 25.6401 35.205 23.333 30.5732V65.3663L43.7497 70.4704V30.5732C41.4456 35.205 38.9839 39.545 37.3097 42.3857Z",
    fill: "url(#paint3_linear_5267_39051)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5267_39051",
    x1: 33.542,
    y1: 0.791016,
    x2: 33.542,
    y2: 41.6243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C73737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#861A1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5267_39051",
    x1: 58.3337,
    y1: 21.2061,
    x2: 58.3337,
    y2: 70.4706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#348BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#193861"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5267_39051",
    x1: 10.2083,
    y1: 21.5664,
    x2: 10.2083,
    y2: 70.7909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#348BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#193861"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5267_39051",
    x1: 33.5413,
    y1: 30.5732,
    x2: 33.5413,
    y2: 70.4704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC7700"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5267_39051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaps);
export default __webpack_public_path__ + "static/media/maps.7c5970e9e5f552dd1dd018149630fdfe.svg";
export { ForwardRef as ReactComponent };